import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Prestation } from 'src/app/shared/models/prestation';
import { Employee } from 'src/app/shared/models/employee/employee';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { Router } from '@angular/router';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-modal-content',
	templateUrl: './prestation-modal-detail-activitePrestation.component.html',
	styleUrls: ['./prestation-modal-detail-activitePrestation.component.scss']
})
export class PrestationModalDetailActivitePrestationComponent implements OnInit {
	/**
	 * Prestation, transmit par le service Modal de ngx dans PrestationModalDetailActivitePrestationComponent
	 */
	prestation: Prestation;

	/**
	 * MissionRequest, transmit par le service Modal de ngx dans PrestationModalDetailActivitePrestationComponent
	 */
	activitePrestation: ActivitePrestation;

	competences;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	confirmDeleteModalRef: BsModalRef;

	isFormReadOnly = true;

	uniqueEmployeeOfMission: Employee;

	LABEL_INTERVENTION: string;

	isValidateButtonClicked: { value: boolean } = { value: false };

	form: FormGroup = new FormGroup(
		{
			cotraitant: new FormControl(),
			description: new FormControl(''),
			chargeTravail: new FormControl('', [ Validators.required, multipleDeQuartValidator()]),
			tache: new FormControl(''),
			intervenant: new FormControl(''),
			modaliteReunion: new FormControl(''),
			dateEntretien: new FormControl<Date>(null, Validators.required),
			//dateProchainEntretien: new FormControl<Date>(null),
			typeEntretien: new FormControl(''),
			bonCommandeReference: new FormControl()
		}
	);

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService,
		private toastService: ToastService,
		private modalService: BsModalService,
		private router: Router,
		private dateUtils: DateUtils
	) { }

	ngOnInit(): void {

	}

	get LABEL_INTERVENANT() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
	}

	get LABEL_BENEFICIAIRE() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_BENEFICIAIRE
		);
	}

	getEmployeeOfMission() {
		const employeeName = this.uniqueEmployeeOfMission
			? this.uniqueEmployeeOfMission.firstName +
			' ' +
			this.uniqueEmployeeOfMission.lastName
			: 'Aucun';
		return employeeName;
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	delete(activitePrestation: ActivitePrestation): void {
		this.facade.activitePrestationService
			.deleteActivitePrestation(activitePrestation.id)
			.subscribe({
				complete: () => {
					this.modalService.hide();
					this.reload();
				},
				error: (err: ErrorResponse) => {
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	updateVolHorairePrevisionnel(): void {
		//let reference = null;
		//this.facade.bonCommandeReferenceService.getAllBonCommandeReference().subscribe({
		//next: (val) =>{

		// reference = val.find((e) => e.cible === this.prestation.statutBeneficiaire
		// && e.quantite - (e.nombreHeuresReelUtil != null ? e.nombreHeuresReelUtil : 0) > this.activitePrestation.chargeTravail
		// && new Date(this.activitePrestation.dateEntretien) > this.dateUtils.convertStringToDate(e.dateDebut) 
		// && new Date(this.activitePrestation.dateEntretien) < this.dateUtils.convertStringToDate(e.dateFin)
		// && e.services.find((e) => e.id === this.activitePrestation.prestation.service?.id));

		// console.log(reference);

		if (this.activitePrestation.bonCommandeReference != null) {
			console.log(this.activitePrestation.dateAffectBdc);
			if (this.activitePrestation.dateAffectBdc == null) {
				this.activitePrestation.bonCommandeReference.nombreHeuresReelUtil = this.activitePrestation.bonCommandeReference.nombreHeuresReelUtil + this.activitePrestation.chargeTravail;
			} else {
				this.activitePrestation.bonCommandeReference.nombreHeuresReelUtil = this.activitePrestation.bonCommandeReference.nombreHeuresReelUtil - this.activitePrestation.oldChargeTravail + this.activitePrestation.chargeTravail;
			}
			this.activitePrestation.dateAffectBdc = new Date().toISOString().slice(0, 10);
			this.facade.bonCommandeReferenceService.updateBonCommandeReference(this.activitePrestation.bonCommandeReference).subscribe({
				next: (val) => {
					this.isValidateButtonClicked.value = true;
					console.log(this.activitePrestation);
					this.facade.activitePrestationService
						.updateActivitePrestation(this.activitePrestation)
						.subscribe({
							complete: () => {
								this.modalService.hide();
								this.isValidateButtonClicked.value = false;
								this.reload();
							},
							error: (err: ErrorResponse) => {
								this.isValidateButtonClicked.value = false;
								this.toastService.createHttpErrorToast(
									err.error.message,
									err.status
								);
							}
						});
				}
			})
		}
		//}
		//})
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		console.log(this.activitePrestation);
		this.facade.activitePrestationService
			.updateActivitePrestation(this.activitePrestation)
			.subscribe({
				complete: () => {
					this.modalService.hide();
					this.isValidateButtonClicked.value = false;
					this.reload();
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
		//this.updateVolHorairePrevisionnel();
	}


}

export function multipleDeQuartValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
	  const value = control.value;
	  if (value == null || value === '') return null;
	  return (value * 100) % 25 === 0 ? null : { notQuarter: true };
	};
  }